import { defineComponent, computed, ref } from 'vue';
import __vue_component__ from '../../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__$2 from '../FilePicker/subComponents/UploadedFileCard.vue.js';
import { getDownloadOptions, downloadOrOpenFile } from './controller.js';
import TransitionExpand from '../../transitions/TransitionExpand/TransitionExpand.js';
import __vue_component__$1 from '../../ui/Loading/Loading.vue.js';
import { DownloadOption } from '../../../database/encryption/model.js';
import { filePickerValueToUploadedFiles } from '../../../functions/useFilePickerValue.js';

var script = defineComponent({
    name: 'FileViewer',
    components: {
        ButtonComponent: __vue_component__,
        Loading: __vue_component__$1,
        TransitionExpand,
        UploadedFileCard: __vue_component__$2,
    },
    props: {
        desktopOptions: {
            type: Array,
            default: () => [DownloadOption.OPEN, DownloadOption.DOWNLOAD],
        },
        displayUploadedFileCard: Boolean,
        downloadLabel: {
            type: String,
            default: 'Download',
        },
        files: {
            type: Array,
            default: null,
        },
        fullWidth: Boolean,
        /**
         * By default, we only show the `download` button on devices detected as
         * mobile based on user agent.
         */
        mobileOptions: {
            type: Array,
            default: () => [DownloadOption.DOWNLOAD],
        },
        multiple: Boolean,
        openLabel: {
            type: String,
            default: 'Open',
        },
        value: {
            type: [String, Object, Array],
            default: null,
        },
        whiteBox: Boolean,
    },
    setup(props, { emit }) {
        const classNames = computed(() => {
            const names = [];
            if (props.fullWidth)
                names.push('FileViewer--full-width');
            return names;
        });
        const isLoadingByLocalID = ref({});
        /** Files can be passed as `FilePickerValue` in `props.value` or as
         * `UploadedFile[]` in `props.files`. However, if `props.value` is used,
         * transitions between value changes will not work properly as random IDs
         * will be generated for each element each time. */
        const computedFiles = computed(() => {
            var _a;
            return (_a = props.files) !== null && _a !== void 0 ? _a : filePickerValueToUploadedFiles(props.value, props.multiple);
        });
        const setLoading = (localID, isLoading) => {
            isLoadingByLocalID.value = {
                ...isLoadingByLocalID.value,
                [localID]: isLoading,
            };
        };
        const downloadOptions = getDownloadOptions(props.desktopOptions, props.mobileOptions, props.openLabel, props.downloadLabel);
        const handleDownloadOptionClicked = async (file, downloadOption) => {
            setLoading(file.localID, true);
            try {
                downloadOrOpenFile(file, downloadOption);
            }
            finally {
                emit('fileViewed');
                setLoading(file.localID, false);
            }
        };
        return {
            DownloadOption,
            classNames,
            computedFiles,
            downloadOptions,
            handleDownloadOptionClicked,
            isLoadingByLocalID,
        };
    },
});

export { script as default };
